import React from "react";

import { GamePlayIcon } from "@pages/casino/assets/icons";

import {
	CardWrapper,
	GameAffiliateName,
	GameCardContentWrapper,
	GameNameWrapper,
	GamePlayArea,
	GameRemoteName,
	ImageWrapper,
} from "./elements.js";
import useController from "./useController.js";

const MostPlayedCard = ({ game, size, type, isGamePage }) => {
	const {
		state: { imageSrc },
		handlers: { handleGameCardClick },
	} = useController({ game, isGamePage, type });

	return (
		<CardWrapper
			hasColorfulShadow={window.CASINO_IMG_HOVER_HAS_COLORFUL_DROP_SHADOW}
			onClick={handleGameCardClick}
			id="most-played-card-wrapper">
			<ImageWrapper
				onClick={handleGameCardClick}
				id="game-image-wrapper"
				data-size={size}>
				<div className="img-container">
					<img
						data-size={size}
						className="big-image"
						src={imageSrc}
					/>
				</div>
				<GameCardContentWrapper>
					<GameNameWrapper>
						<GameRemoteName>
							{game?.remote_name && game.remote_name.length > 32
								? `${game.remote_name.slice(0, 29)}...`
								: game.remote_name}
						</GameRemoteName>
						<GameAffiliateName>{game?.affiliate}</GameAffiliateName>
					</GameNameWrapper>
					<GamePlayArea>
						<GamePlayIcon onClick={handleGameCardClick} />
					</GamePlayArea>
				</GameCardContentWrapper>
			</ImageWrapper>
			<div className="sparkle"></div>
			<div className="sparkle"></div>
			<div className="sparkle"></div>
			<div className="sparkle"></div>
		</CardWrapper>
	);
};

export default MostPlayedCard;
